/*
 * @Author: dongzhuo
 * @Date: 2020-12-29 10:00:38
 * @LastEditTime: 2021-05-10 14:46:23
 * @FilePath: \welink-template\src\store\modules\user.js
 * @Description: 用户信息、以及用户对应菜单等信息
 */
import { login, getInfo, logOut, wxlogin, bindLogin } from "@/services/api";
import { getToken, setToken, removeToken } from "@/services/auth";
import { resetRouter } from "@/router";

const getDefaultState = () => {
  return {
    token: getToken(),
    userInfo: {}, // 用户信息
    loginType: {
      key: "mobile",
      value: "手机号登录",
    },
    // 微信公众号 扫码 唯一身份编号
    weChatID: Math.round(Math.random()*255) + "" + new Date().getTime(),
  };
};
const state = getDefaultState();

const mutations = {
  RESET_STATE: state => {
    Object.assign(state, getDefaultState());
  },
  SET_TOKEN: (state, token) => {
    state.token = token;
    console.log("user setTOken", token);
    setToken(token);
  },
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo;
  },
  SET_USER_TYPE: (state, type) => {
    state.loginType = type;
    localStorage.setItem("loginType", JSON.stringify(type));
  },
};

const actions = {
  login({ commit, state }, mobileLoginForm) {
    return new Promise((resolve, reject) => {
      login({

        phone: mobileLoginForm.mobile,
        code: mobileLoginForm.yzm,
        scope: "phone"
      })
        .then(response => {
          console.log("request user mobilelogin...", response);
          const { token } = response.content.data.token;
          commit("SET_TOKEN", response.content.data.token);
          commit("SET_USER_TYPE", {key:"mobile",value:"手机登录"});
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  bindLogin({ commit, state }, mobileLoginForm) {
    return new Promise((resolve, reject) => {
      bindLogin({
        phone: mobileLoginForm.mobile,
        code: mobileLoginForm.yzm,
        scope: "phone"
      })
        .then(response => {
          console.log("request user mobilelogin...", response);
          const { token } = response.content.data.token;
          commit("SET_TOKEN", response.content.data.token);
          // commit("SET_USER_INFO", response.content.data);
          // getInfo({ commit, state });         
          
          commit("SET_USER_TYPE", {key:"mobile",value:"微信扫码登录"});
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  wxlogin({ commit, state }, wechatform) {

    console.log("request wxlogin start", wechatform);
    return new Promise((resolve, reject) => {
      wxlogin({
        code: wechatform.code,
        state: wechatform.wxstate,
      })
        .then(response => {
          console.log("request user wxlogining...", response);
          const { token } = response.content.data.token;
          commit("SET_TOKEN", response.content.data.token);
          commit("SET_USER_TYPE", {key:"weChat",value:"微信扫码登录"});
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token)
        .then(response => {
          const { userMenuPaths } = response.content;
          console.log("this.getinfo,", response);
          commit("SET_USER_INFO", response.content);
          // commit("SET_USER_TYPE", response.content.userPlat[0]); //默认站点是第一个
          resolve();
        })
        .catch(error => {
          console.log("this.getinfo,", state);

          reject(error);
        });
    });
  },
  // 退出登录
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logOut(state.token)
        .then(() => {
          removeToken();
          commit("RESET_STATE");
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  // 移除token并初始化信息
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken();
      commit("RESET_STATE");
      resolve();
    });
  },
  // 设置站点
  setUserType({ commit }, type) {
    commit("SET_USER_TYPE", type);
  },
  // 设置 微信公众号扫码 TOKEN
  setUserToken({ commit }, token) {
    commit("SET_USER_TYPE", {key:"weChat",value:"微信扫码登录"});
    commit("SET_TOKEN", token);
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
